var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGear(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1928_2309)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10 13.125C11.7259 13.125 13.125 11.7259 13.125 10C13.125 8.27411 11.7259 6.875 10 6.875C8.27411 6.875 6.875 8.27411 6.875 10C6.875 11.7259 8.27411 13.125 10 13.125Z",
    stroke: "#6130B5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.23691 13.9133C2.89158 13.3185 2.62701 12.6803 2.4502 12.0156L3.76113 10.375C3.74629 10.1242 3.74629 9.87271 3.76113 9.62189L2.45098 7.98126C2.62749 7.31648 2.89152 6.67809 3.23613 6.08282L5.32285 5.84845C5.48949 5.66071 5.66714 5.48305 5.85488 5.31642L6.08926 3.23048C6.68366 2.88751 7.32101 2.62505 7.98457 2.45001L9.6252 3.76095C9.87602 3.74611 10.1275 3.74611 10.3783 3.76095L12.0189 2.45079C12.6837 2.62731 13.3221 2.89134 13.9174 3.23595L14.1518 5.32267C14.3395 5.4893 14.5172 5.66696 14.6838 5.8547L16.7697 6.08907C17.1151 6.68389 17.3796 7.32205 17.5564 7.98673L16.2455 9.62736C16.2604 9.87818 16.2604 10.1297 16.2455 10.3805L17.5557 12.0211C17.3804 12.6857 17.1177 13.3241 16.7744 13.9195L14.6877 14.1539C14.5211 14.3417 14.3434 14.5193 14.1557 14.6859L13.9213 16.7719C13.3265 17.1172 12.6883 17.3818 12.0236 17.5586L10.383 16.2477C10.1322 16.2625 9.88071 16.2625 9.62988 16.2477L7.98926 17.5578C7.32467 17.3825 6.68628 17.1198 6.09082 16.7766L5.85645 14.6899C5.66871 14.5232 5.49105 14.3456 5.32441 14.1578L3.23691 13.9133Z",
    stroke: "#6130B5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1928_2309"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGear);
export default __webpack_public_path__ + "static/media/gear.e2f710c2b97b171cdfc5e3aed5797c6c.svg";
export { ForwardRef as ReactComponent };